import { Redirect, useLocalSearchParams } from "expo-router";

import { normalizeSearchParam } from "@/utils/routing";

export default function ShortCodeRedirect() {
  const { code } = useLocalSearchParams<{ code: string }>();

  const normalizedCode = normalizeSearchParam(code);

  return (
    <Redirect
      href={{
        pathname: "/(unauthed)/onboarding",
        params: { code: normalizedCode },
      }}
    />
  );
}
